import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initRum, reportRouterError } from "@utils/rum";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { FronteraAuthProvider } from "@fronterahealth/frontera-auth0-react";

import { router } from "./App.tsx";
import "./index.css";

initRum();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <FronteraAuthProvider
      loginOnMount={false}
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      audience={import.meta.env.VITE_AUTH0_AUDIENCE}
    >
      <QueryClientProvider client={queryClient}>
        <ToastContainer pauseOnFocusLoss={false} autoClose={2000} hideProgressBar />
        <RouterProvider router={router} onError={reportRouterError} />
      </QueryClientProvider>
    </FronteraAuthProvider>
  </StrictMode>,
);
